import React from 'react';
import { Modal, Button, Form, Input, Icon, Tabs } from 'antd';

import Productos from './ViewModal/Productos';
import Footer from './FormModal/Footer';

const InputGroup = Input.Group;
const { TabPane } = Tabs;

export default class ViewModal extends React.Component {
    render() {
        return (
            <Modal
                title={"Retención"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                style={{ top: 30 }}
                width={1100}
                footer={[
                    <Button
                        key="1"
                        onClick={this.props.onClose}
                    >
                        Cancelar
                    </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-3">
                            <Form.Item label="Fecha / Tipo de Cambio">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.fechaStr}
                                        suffix={<Icon type="calendar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                    />
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.tipoCambio}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Serie / Documento">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '40%' }}
                                        value={this.props.formValues.serie}
                                    />
                                    <Input readOnly
                                        style={{ width: '60%' }}
                                        value={this.props.formValues.documento}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Establecimiento">
                                <Input readOnly
                                    value={this.props.formValues.nombreEstablecimiento}
                                />
                            </Form.Item>
                        </div>
                        <div className="col-md-3">
                            <Form.Item label="Tasa">
                                <Input readOnly
                                    value="3%"
                                />
                            </Form.Item>
                        </div>
                   
                    </div>
        
                    <div className="row">
                        <div className="col-md-6">
                            <Form.Item label="Cliente">
                                <InputGroup compact>
                                    <Input readOnly
                                        style={{ width: '35%' }}
                                        value={this.props.formValues.numeroDocumentoCliente}
                                    />
                                    <Input readOnly
                                        style={{ width: '65%' }}
                                        value={this.props.formValues.nombreCliente}
                                    />
                                </InputGroup>
                            </Form.Item>
                        </div>
                        <div className="col-md-6">
                            <Form.Item label="Dirección">
                                <Input readOnly
                                    value={this.props.formValues.direccionCliente}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <Form.Item label="Observación">
                                <Input readOnly
                                    value={this.props.formValues.observacion}
                                />
                            </Form.Item>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <Tabs>
                                <TabPane tab="Detalle de Comprobantes" key="1">
                                    <Productos
                                        dataSource={this.props.formValues.detalles}
                                    />
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                  {/*   <Footer
                        formValues={this.props.formValues}
                    /> */}
                </Form>
            </Modal>
        );
    }
}